import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./IntroAnimation.css";

const IntroAnimation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/welcome");
    }, 5200); // ⏳ Give tagline time to show fully
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="intro-bg">
      {/* B */}
      <motion.span
        className="letter glow"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{
          opacity: [0, 1, 1, 0],
          scale: [0.5, 1, 1, 1],
          x: [0, 0, 0, 100],
        }}
        transition={{
          delay: 0,
          duration: 4,
          times: [0, 0.3, 0.55, 1],
          ease: "easeInOut",
        }}
      >
        B
      </motion.span>

      {/* Y */}
      <motion.span
        className="letter final-zoom"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{
          opacity: [0, 1, 1, 1],
          scale: [0.5, 1, 1, 300],
        }}
        transition={{
          delay: 0.5,
          duration: 4,
          times: [0, 0.25, 0.7, 1],
          ease: "easeInOut",
        }}
      >
        Y
      </motion.span>

      {/* N */}
      <motion.span
        className="letter glow"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{
          opacity: [0, 1, 1, 0],
          scale: [0.5, 1, 1, 1],
          x: [0, 0, 0, -100],
        }}
        transition={{
          delay: 1,
          duration: 3,
          times: [0, 0.2, 0.45, 1],
          ease: "easeInOut",
        }}
      >
        N
      </motion.span>

      {/* ✅ Tagline */}
      <motion.div
        className="tagline"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 3.2, duration: 1.2 }}
      >
        Book Your Need – Your life. Simplified.
      </motion.div>
    </div>
  );
};

export default IntroAnimation;
